app.service('vue', function ($global, console) {
	function setData(name, data) {
		console.log(name, data)
	}
	$global('vue', setData);
	return {
		setData
	};
});